// extracted by mini-css-extract-plugin
export default {"component":"TransferToOfficeModal_component__M4B7U","modalContainer":"TransferToOfficeModal_modalContainer__OPNee","input":"TransferToOfficeModal_input__68HTj"};